import { LOCALE_ID, NgModule } from '@angular/core';
import {
  LytxCoreModule,
  MonitoringService,
  MultiSelectDropdownModule,
} from '@lytx/platform.ui.components';
import { MonitoringOverrideService } from './monitoring-override.service';

// const l10Service = {
//   getLocale: () => {
//     return { language: 'en-US' };
//   },
// };

@NgModule({
  declarations: [],
  imports: [MultiSelectDropdownModule, LytxCoreModule],
  exports: [MultiSelectDropdownModule, LytxCoreModule],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
      // deps: [L10nTranslationService],
    },
    { provide: MonitoringService, useClass: MonitoringOverrideService },
    // { provide: L10nTranslationService, useValue: l10Service },
  ],
})
export class LytxPlatformComponentsModule {}
